import moment from "moment";
import React, { useContext, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  LanguageContext,
} from "../../../App";
import "react-calendar/dist/Calendar.css";
import Calendar from "react-calendar";
import { useState } from "react";

function NonAttendeeBooking({
  setStepper,
  bookingDetails,
  setBookingDetails,
  bookingSets,
  setBookingSets,
}) {
  const history = useHistory();
  const { language } = useContext(LanguageContext);
  const [tabOpen, setTabOpen] = useState(1);
  const [contUnavail, setContUnavail] = useState([]);
  const [openCal, setOpenCal] = useState(true);
  const [sectionTab, setSectionTab] = useState(1);

  //

  const checkNext = () => {
    if (bookingDetails?.branch?.name && bookingDetails?.time?.length != 0)
      return true;
    else return false;
  };

  const onMinus = () => {
    if (bookingDetails?.attendee != 1) {
      setBookingDetails((a) => ({ ...a, attendee: a?.attendee - 1 }));
    }
  };

  const onPlus = () => {
    if (bookingDetails?.attendee != bookingSets?.maxAttend) {
      setBookingDetails((a) => ({ ...a, attendee: a?.attendee + 1 }));
    }
  };

  useEffect(() => {
    let l = [];
    let total = bookingSets?.timeSlot + bookingSets?.buffer;
    let temp = bookingDetails?.time?.map((i) =>
      moment(new Date(`01-01-2012, ${i}`))?.locale("en")
    );
    if (bookingDetails?.branch == "") {
      if (temp?.length != bookingSets?.max && temp?.length != 0) {
        let o = moment(temp[0]);
        let p = moment(temp[temp?.length - 1]);
        let a = true;
        let b = true;
        for (let i = 0; i < bookingSets?.max - temp?.length; i++) {
          if (
            bookingSets?.unTime?.includes(
              p?.add(total, "minutes")?.format("HH:mm:ss")
            )
          )
            a = false;
          if (
            bookingSets?.unTime?.includes(
              o?.subtract(total, "minutes")?.format("HH:mm:ss")
            )
          )
            b = false;
          if (a) l?.push(p?.format("hh:mm a"));
          if (b) l?.push(o?.format("hh:mm a"));
        }
      }
      setContUnavail(l);
    }
  }, [bookingDetails]);

  const sortTime = (i, j) => {
    i = new Date(`01-01-2012, ${i}`);
    j = new Date(`01-01-2012, ${j}`);
    i = moment(i);
    j = moment(j);
    return i?.format("HH:mm") < j?.format("HH:mm") ? -1 : 1;
  };

  const onTimeClick = (i) => {
    if (bookingSets?.cont) {
      let temp = bookingDetails?.time;
      if (!bookingDetails?.time?.includes(i)) {
        if (temp?.length < bookingSets?.max) temp?.push(i);
      } else {
        temp = temp.filter((f) => f !== i);
      }
      temp = temp?.sort(sortTime);
      setBookingDetails((s) => ({
        ...s,
        time: temp,
        time_ar: temp?.map(
          (k) =>
            `${moment(new Date(`01-01-2012, ${k}`))
              ?.locale("en")
              ?.format("hh:mm")} ${moment(new Date(`01-01-2012, ${k}`))
                ?.locale("ar")
                ?.format("a")}`
        ),
      }));
    } else {
      let temp = bookingDetails?.time;
      if (temp?.length == 0) {
        temp?.push(i);
      } else if (temp?.length == 1 && temp?.includes(i)) {
        temp = [];
      } else if (
        temp?.length == 1 &&
        !temp?.includes(i) &&
        temp?.length != bookingSets?.max
      ) {
        let k = moment(new Date(`01-01-2012, ${i}`))?.locale("en");
        let l = moment(new Date(`01-01-2012, ${temp[0]}`))?.locale("en");
        let total = bookingSets?.timeSlot + bookingSets?.buffer;

        let m = moment(
          new Date(`01-01-2012, ${temp[temp?.length - 1]}`)
        )?.locale("en");
        if (k < l) {
          while (true) {
            if (moment(k) < moment(l)) {
              temp.push(k?.format("hh:mm a"));
              k?.add(total, "minutes");
            } else break;
          }
        } else {
          while (true) {
            if (moment(m) < moment(k)) {
              m?.add(total, "minutes");
              temp.push(m?.format("hh:mm a"));
            } else break;
          }
        }
      } else {
        temp = [];
        temp?.push(i);
      }
      temp = temp?.sort(sortTime);
      setBookingDetails((s) => ({
        ...s,
        time: temp,
        time_ar: temp?.map(
          (k) =>
            `${moment(new Date(`01-01-2012, ${k}`))
              ?.locale("en")
              ?.format("hh:mm")} ${moment(new Date(`01-01-2012, ${k}`))
                ?.locale("ar")
                ?.format("a")}`
        ),
      }));
    }
  };

  return (
    <>
      <div style={{ paddingBottom: 10 }}>
        <div
          className="checkout-step-one"
          style={{ paddingRight: 0, paddingLeft: 0 }}
        >
          <h1
            className="main-heading"
            style={{ paddingRight: 16, paddingLeft: 16 }}
          >
            {language == "ltr" ? "Reservations" : "التحفظات"}
          </h1>
          <div className="checkout-one">
            <div
              className="booking-single-div"
              style={{ borderBottom: "none" }}
            >
              <div className="booking-flex-div" onClick={() => setTabOpen(1)}>
                <p className="booking-sub-title">
                  {language == "ltr" ? "Date" : "التاريخ"}
                </p>
                <p className="booking-info-text">
                  {language == "ltr" ? (
                    bookingDetails?.date?.format("D MMM YYYY")
                  ) : (
                    <>
                      <span style={{ fontSize: 18 }} className="number-span">
                        {bookingDetails?.date?.format("D")}
                      </span>{" "}
                      {moment(bookingDetails?.date)
                        ?.locale("ar")
                        ?.format("MMM")}{" "}
                      <span style={{ fontSize: 18 }} className="number-span">
                        {bookingDetails?.date?.format("YYYY")}
                      </span>
                    </>
                  )}
                </p>
              </div>
              <div className="pt-3">
                <p
                  className="booking-info-text open-calendar"
                  onClick={() => setOpenCal((a) => !a)}
                >
                  {!openCal
                    ? language == "ltr"
                      ? "Open Calendar"
                      : "افتح التقويم"
                    : language == "ltr"
                      ? "Close Calendar"
                      : "أغلق التقويم"}
                </p>
                <div
                  style={openCal ? {} : { display: "none" }}
                  className="booking-calendar-container"
                >
                  <Calendar
                    minDetail="year"
                    onChange={(e) => {
                      setBookingSets((a) => ({
                        ...a,
                        date: moment(e)?.locale("en"),
                      }));
                      setBookingDetails((a) => ({
                        ...a,
                        date: moment(e)?.locale("en"),
                      }));
                      setOpenCal((a) => !a);
                    }}
                    value={bookingDetails?.date?.toDate()}
                    minDate={bookingSets?.dateNow?.toDate()}
                  />
                </div>
                <div
                  style={!openCal ? {} : { display: "none" }}
                  className="date-scroller"
                >
                  {[...Array(2)].map((k, i) =>
                    moment(bookingSets?.date)
                      ?.startOf("day")
                      .locale("en")
                      .subtract(2 - i, "days") >=
                      moment(bookingSets?.dateNow)?.startOf("day") ? (
                      <span
                        onClick={() => {
                          setBookingDetails((book) => ({
                            ...book,
                            time: [],
                            time_ar: [],
                            branch: "",
                            date: moment(bookingSets?.date)
                              .locale("en")
                              .subtract(2 - i, "days"),
                          }));
                          setTabOpen((t) => 2);
                        }}
                        className={`date-selector ${moment(bookingSets?.date)
                          .locale("en")
                          .subtract(2 - i, "days")
                          ?.format("D MMM YYYY") ==
                          bookingDetails?.date?.format("D MMM YYYY")
                          ? "booking-slot-active"
                          : ""
                          }`}
                      >
                        <span
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <span>
                            {moment(bookingSets?.date)
                              .locale(language == "ltr" ? "en" : "ar")
                              .subtract(2 - i, "days")
                              ?.format("ddd")}
                          </span>

                          {language == "ltr" ? (
                            <span>
                              {moment(bookingSets?.date)
                                .locale("en")
                                .subtract(2 - i, "days")
                                ?.format("D MMM YYYY")}
                            </span>
                          ) : (
                            <span>
                              <span
                                style={{ fontSize: 13 }}
                                className="number-span"
                              >
                                {moment(bookingSets?.date)
                                  .locale("en")
                                  .subtract(2 - i, "days")
                                  ?.format("D")}
                              </span>{" "}
                              {moment(bookingSets?.date)
                                ?.locale("ar")
                                ?.subtract(2 - i, "days")
                                ?.format("MMM")}{" "}
                              <span
                                style={{ fontSize: 13 }}
                                className="number-span"
                              >
                                {moment(bookingSets?.date)
                                  .locale("en")
                                  .subtract(2 - i, "days")
                                  ?.format("YYYY")}
                              </span>
                            </span>
                          )}
                        </span>
                      </span>
                    ) : null
                  )}
                  {[...Array(30)].map((k, i) => (
                    <span
                      onClick={() => {
                        setBookingDetails((book) => ({
                          ...book,
                          time: [],
                          time_ar: [],
                          branch: "",
                          date: moment(bookingSets?.date)
                            .locale("en")
                            .add(i, "days"),
                        }));
                        setTabOpen((t) => 2);
                      }}
                      className={`date-selector ${moment(bookingSets?.date)
                        .locale("en")
                        .add(i, "days")
                        ?.format("D MMM YYYY") ==
                        bookingDetails?.date?.format("D MMM YYYY")
                        ? "booking-slot-active"
                        : ""
                        }`}
                    >
                      <span
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <span>
                          {moment(bookingSets?.date)
                            .locale(language == "ltr" ? "en" : "ar")
                            .add(i, "days")
                            ?.format("ddd")}
                        </span>

                        {language == "ltr" ? (
                          <span>
                            {moment(bookingSets?.date)
                              .locale("en")
                              .add(i, "days")
                              ?.format("D MMM YYYY")}
                          </span>
                        ) : (
                          <span>
                            <span
                              style={{ fontSize: 13 }}
                              className="number-span"
                            >
                              {moment(bookingSets?.date)
                                .locale("en")
                                .add(i, "days")
                                ?.format("D")}
                            </span>{" "}
                            {moment(bookingSets?.date)
                              ?.locale("ar")
                              ?.add(i, "days")
                              ?.format("MMM")}{" "}
                            <span
                              style={{ fontSize: 13 }}
                              className="number-span"
                            >
                              {moment(bookingSets?.date)
                                .locale("en")
                                .add(i, "days")
                                ?.format("YYYY")}
                            </span>
                          </span>
                        )}
                      </span>
                    </span>
                  ))}
                </div>
              </div>
            </div>
            <div
              style={
                openCal
                  ? { display: "none", marginBottom: 40 }
                  : { marginBottom: 40 }
              }
            >
              <div className="booking-search-selection">
                <div
                  className="booking-section"
                  onClick={() => setSectionTab(1)}
                >
                  <p className="booking-sub-title">
                    {language == "ltr" ? "Branch" : "أفرعنا"}
                  </p>
                  <p
                    style={{
                      textAlign: "center",
                      fontSize: language == "ltr" ? 16 : 19,
                      height: 19,
                    }}
                    className="booking-info-text"
                  >
                    {bookingDetails?.branch == ""
                      ? " "
                      : language == "ltr"
                        ? bookingDetails?.branch?.name
                        : bookingDetails?.branch?.arabic_name}
                  </p>
                </div>
                <div
                  onClick={() => setSectionTab(2)}
                  style={
                    language == "ltr"
                      ? { borderLeft: "5px solid #efefef" }
                      : { borderRight: "5px solid #efefef" }
                  }
                  className="booking-section"
                >
                  <p className="booking-sub-title">
                    {language == "ltr" ? "Time" : "الوقت"}
                  </p>
                  <p
                    style={{
                      textAlign: "center",
                      fontSize: language == "ltr" ? 16 : 19,
                      height: 19,
                    }}
                    className="booking-info-text"
                  >
                    {bookingDetails?.time?.length == 0 ? (
                      " "
                    ) : bookingSets?.cont ||
                      bookingDetails?.time?.length == 1 ? (
                      language == "ltr" ? (
                        bookingDetails?.time?.join(", ")
                      ) : (
                        bookingDetails?.time_ar?.map((k, m) => (
                          <>
                            {m != 0 ? ", " : ""}
                            <span
                              style={{ fontSize: 16 }}
                              className="number-span"
                            >
                              {k.split(" ")[0]}
                            </span>{" "}
                            {k?.split(" ")[1]}
                          </>
                        ))
                      )
                    ) : language == "ltr" ? (
                      `${bookingDetails?.time[0]} - ${bookingDetails?.time[bookingDetails?.time?.length - 1]
                      }`
                    ) : (
                      <>
                        <span style={{ fontSize: 16 }} className="number-span">
                          {bookingDetails?.time_ar[0]?.split(" ")[0]}
                        </span>{" "}
                        {bookingDetails?.time_ar[0]?.split(" ")[1]}
                        {" - "}
                        <span style={{ fontSize: 16 }} className="number-span">
                          {
                            bookingDetails?.time_ar[
                              bookingDetails?.time_ar?.length - 1
                            ]?.split(" ")[0]
                          }
                        </span>{" "}
                        {
                          bookingDetails?.time_ar[
                            bookingDetails?.time_ar?.length - 1
                          ]?.split(" ")[1]
                        }
                      </>
                    )}
                  </p>
                </div>
                <i
                  style={
                    sectionTab == 1
                      ? { left: language == "ltr" ? "24%" : "74%" }
                      : { left: language == "ltr" ? "74%" : "24%" }
                  }
                  className="fas fa-caret-up booking-arrow"
                ></i>
              </div>
              <div style={{ paddingTop: 20 }}>
                {sectionTab == 1 ? (
                  <ul className="booking-branch-list">
                    {bookingSets?.branches?.map((k) => (
                      <li className="booking-branch">
                        <img
                          className="booking-branch-img"
                          src={k?.image}
                        ></img>
                        <div className="booking-branch-details">
                          <div className="booking-branch-title">
                            {language == "ltr" ? k?.name : k?.arabic_name}
                          </div>
                          <div className="booking-branch-desc">
                            {language == "ltr"
                              ? k?.description
                              : k?.arabic_description}
                          </div>
                          <div
                            className={`booking-branch-button ${bookingSets?.unBranch?.includes(k?.id)
                              ? "booking-branch-none"
                              : ""
                              }`}
                          >
                            <button
                              onClick={() => {
                                if (!bookingSets?.unBranch?.includes(k?.id)) {
                                  setBookingDetails((book) => ({
                                    ...book,
                                    branch: k,
                                  }));
                                  setSectionTab((t) => 2);
                                }
                              }}
                            >
                              {bookingSets?.unBranch?.includes(k?.id)
                                ? language == "ltr"
                                  ? "Unavailable"
                                  : "غير متوفره"
                                : language == "ltr"
                                  ? "Select"
                                  : "يختار"}
                            </button>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <div className="booking-time-div">
                    {bookingSets?.timeMorning?.length != 0 && (
                      <div className="booking-time-period">
                        <p className="booking-time-text">
                          {language == "ltr" ? "Morning" : "صباح"}
                        </p>
                        <div className="booking-time-slot-div">
                          {bookingSets?.timeMorning?.map((i, k) => (
                            <button
                              onClick={() => {
                                if (
                                  !bookingSets?.unTime?.includes(
                                    moment(new Date(`01-01-2012, ${i}`))
                                      ?.locale("en")
                                      ?.format("HH:mm:ss")
                                  )
                                )
                                  if (
                                    bookingDetails?.time?.length != 1 ||
                                    bookingDetails?.time?.includes(i) ||
                                    bookingSets?.cont
                                  )
                                    onTimeClick(i);
                                  else {
                                    if (contUnavail?.includes(i))
                                      onTimeClick(i);
                                  }
                              }}
                              className={`booking-time-slot ${bookingDetails?.time?.includes(i)
                                ? "booking-slot-active"
                                : ""
                                } ${bookingSets?.unTime?.includes(
                                  moment(new Date(`01-01-2012, ${i}`))
                                    ?.locale("en")
                                    ?.format("HH:mm:ss")
                                ) ||
                                  (bookingDetails?.time?.length == 1 &&
                                    !bookingDetails?.time?.includes(i) &&
                                    !contUnavail?.includes(i) &&
                                    !bookingSets?.cont) ||
                                  (bookingSets?.cont &&
                                    !bookingDetails?.time?.includes(i) &&
                                    bookingDetails?.time?.length ==
                                    bookingSets?.max)
                                  ? "booking-time-booked"
                                  : ""
                                }`}
                            >
                              {language == "ltr" ? (
                                `${i} -
                                ${moment(new Date(`01-01-2012, ${i}`))
                                  ?.locale("en")
                                  ?.add(bookingSets?.timeSlot, "minutes")
                                  ?.format("hh:mm a")}`
                              ) : (
                                <>
                                  <span
                                    style={{ fontSize: 12 }}
                                    className="number-span"
                                  >
                                    {moment(new Date(`01-01-2012, ${i}`))
                                      ?.locale("en")
                                      ?.format("hh:mm")}
                                  </span>{" "}
                                  {moment(new Date(`01-01-2012, ${i}`))
                                    ?.locale("ar")
                                    ?.format("a")}{" "}
                                  -{" "}
                                  <span
                                    style={{ fontSize: 12 }}
                                    className="number-span"
                                  >
                                    {moment(new Date(`01-01-2012, ${i}`))
                                      ?.locale("en")
                                      .add(bookingSets?.timeSlot, "minutes")
                                      ?.format("hh:mm")}
                                  </span>{" "}
                                  {moment(new Date(`01-01-2012, ${i}`))
                                    ?.locale("ar")
                                    .add(bookingSets?.timeSlot, "minutes")
                                    ?.format("a")}
                                </>
                              )}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}
                    {bookingSets?.timeEvening?.length != 0 && (
                      <div
                        className="booking-time-period"
                        style={{
                          paddingTop:
                            bookingSets?.timeMorning?.length == 0 ? 0 : 16,
                        }}
                      >
                        <p className="booking-time-text">
                          {language == "ltr" ? "Evening" : "مساء"}
                        </p>
                        <div className="booking-time-slot-div">
                          {bookingSets?.timeEvening?.map((i, k) => (
                            <button
                              onClick={() => {
                                // setBookingDetails((book) => ({ ...book, time: i }))
                                if (
                                  !bookingSets?.unTime?.includes(
                                    moment(new Date(`01-01-2012, ${i}`))
                                      ?.locale("en")
                                      ?.format("HH:mm:ss")
                                  )
                                )
                                  if (
                                    bookingDetails?.time?.length != 1 ||
                                    bookingDetails?.time?.includes(i) ||
                                    bookingSets?.cont
                                  )
                                    onTimeClick(i);
                                  else {
                                    if (contUnavail?.includes(i))
                                      onTimeClick(i);
                                  }
                              }}
                              className={`booking-time-slot ${bookingDetails?.time?.includes(i)
                                ? "booking-slot-active"
                                : ""
                                } ${bookingSets?.unTime?.includes(
                                  moment(new Date(`01-01-2012, ${i}`))
                                    ?.locale("en")
                                    ?.format("HH:mm:ss")
                                ) ||
                                  (bookingDetails?.time?.length == 1 &&
                                    !bookingDetails?.time?.includes(i) &&
                                    !contUnavail?.includes(i) &&
                                    !bookingSets?.cont) ||
                                  (bookingSets?.cont &&
                                    !bookingDetails?.time?.includes(i) &&
                                    bookingDetails?.time?.length ==
                                    bookingSets?.max)
                                  ? "booking-time-booked"
                                  : ""
                                }`}
                            >
                              {language == "ltr" ? (
                                `${i} -
                                ${moment(new Date(`01-01-2012, ${i}`))
                                  ?.locale("en")
                                  ?.add(bookingSets?.timeSlot, "minutes")
                                  ?.format("hh:mm a")}`
                              ) : (
                                <>
                                  <span
                                    style={{ fontSize: 12 }}
                                    className="number-span"
                                  >
                                    {moment(new Date(`01-01-2012, ${i}`))
                                      ?.locale("en")
                                      ?.format("hh:mm")}
                                  </span>{" "}
                                  {moment(new Date(`01-01-2012, ${i}`))
                                    ?.locale("ar")
                                    ?.format("a")}{" "}
                                  -{" "}
                                  <span
                                    style={{ fontSize: 12 }}
                                    className="number-span"
                                  >
                                    {moment(new Date(`01-01-2012, ${i}`))
                                      ?.locale("en")
                                      .add(bookingSets?.timeSlot, "minutes")
                                      ?.format("hh:mm")}
                                  </span>{" "}
                                  {moment(new Date(`01-01-2012, ${i}`))
                                    ?.locale("ar")
                                    .add(bookingSets?.timeSlot, "minutes")
                                    ?.format("a")}
                                </>
                              )}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="bottom-button iphone-issue"
        style={{ position: "absolute", width: "100%" }}
      >
        <Link
          onClick={(e) => {
            e.preventDefault();
            history.goBack();
          }}
          className="text-center checkout-button checkout-button-back"
        >
          {language == "ltr" ? "Back" : "تراجع"}
        </Link>
        <Link
          onClick={(e) => {
            e.preventDefault();
            if (checkNext()) setStepper((stepper) => stepper + 1);
          }}
          className="text-center checkout-button checkout-button-next"
        >
          {checkNext()
            ? language == "ltr"
              ? "Next"
              : "متابعة"
            : language == "ltr"
              ? "Select all the fields"
              : "حدد جميع الحقول"}
        </Link>
      </div>
    </>
  );
}

export default NonAttendeeBooking;
